import React from "react";
import {createBrowserRouter} from "react-router";
import HomePage from "../pages/HomePage";
import MiniKalkulator from "../pages/MiniKalkulator";
//import HomePage from "../pages/HomePage";
//import Dashboard from "../pages/Dashboard";
//import {action as logoutAction} from "../pages/Logout";
//import {createBrowserRouter, redirect} from "react-router-dom";
import RootLayout from "../pages/RootLayout";
//import {getAuthToken} from "../utils/auth";
//import AddOrganizationalUnit from "../pages/OrganizationalUnit/AddOrganizationalUnit";

//const checkAuthPublicRoute = async () => {
//    const token = getAuthToken();
//    if (token) {
//        return redirect('/');
//    }
//    return null;
//};

//const checkAuthPrivateRoute = async () => {
//    const token = getAuthToken();

//    if (!token) {
//        return redirect('/auth?mode=login');
//    }
//    return null;
//}

const Router = createBrowserRouter([
    {
        path: '/',
        element: <RootLayout />,
        errorElement: <div>Error</div>,
        id: "root",
        //loader: getAuthToken,
        children: [
            {
                index: true,
                element: <HomePage/>
            }
            ,
            {
                path: '/MiniKalkulator',
                element:<MiniKalkulator/>
            }
            /*
            ,
            {
                path: 'auth',
                element: <AuthenticationPage />,
                action: authAction,
                loader: checkAuthPublicRoute
            },
            {
                path: 'account',
                loader: checkAuthPrivateRoute,
                children: [
                    {
                        path: 'settings',
                        element: <AccountSettings />
                    },
                    {
                        path: 'change-password',
                        element: <div>Change password</div>
                    },
                ]
            }*/
        ]
    }
])

export default Router;
